/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const UploadIcon = React.forwardRef<HTMLDivElement, BaseIconProps>(
  ({size = 16, ...props}, ref) => {
    return (
      <BaseIcon {...props} size={size} ref={ref}>
        <svg
          data-wf-icon="UploadIcon"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <g>
              <path
                d="M4.12008 5.02383C4.55596 3.2864 6.12738 2 8 2C9.87262 2 11.444 3.2864 11.8799 5.02383C13.3574 5.21056 14.5 6.47184 14.5 8C14.5 9.4865 13.4189 10.7205 12 10.9585V9.93699C12.8626 9.71497 13.5 8.93192 13.5 8C13.5 6.89598 12.6055 6.00089 11.5017 6L11.5 6L11.0314 6.0033L10.9696 5.57101C10.7618 4.11754 9.51099 3 8 3C6.48901 3 5.23817 4.11753 5.03038 5.57101L4.96858 6.00326L4.49835 6C3.39454 6.00089 2.5 6.89598 2.5 8C2.5 8.93192 3.13739 9.71497 4 9.93699V10.9585C2.58114 10.7205 1.5 9.4865 1.5 8C1.5 6.47184 2.64259 5.21055 4.12008 5.02383Z"
                fill="currentColor"
              />
              <path
                d="M5.85355 9.85355L7.5 8.20711V13H8.5V8.20711L10.1464 9.85355L10.8536 9.14645L8 6.29289L5.14645 9.14645L5.85355 9.85355Z"
                fill="currentColor"
              />
            </g>
          </g>
        </svg>
      </BaseIcon>
    );
  }
) as IconComponent;

UploadIcon.tags = [
  'cloud',
  'arrow',
  'share',
  'upload',
  'send',
  'data',
  'transfer',
];

UploadIcon.category = 'General Icons';

UploadIcon.iconSize = 16;
